import React from "react";
import Styled from "styled-components";

const Badges = function(props) {


  const Badge = Styled.p`
        font-size: 6em;
        display: block;
        margin: 10px;
        color: #D3D3D3;
        text-align: center;

        &:hover {
          color: ${props.color};
        }

        @media (max-width: 1024px) {
          font-size: 5em;
      }
        
        @media (max-width: 900px) {
          font-size: 4em;
          display: inline-block;
      }

        @media (max-width: 700px) {
            font-size: 3em;
        }
    `;

  return <Badge>{props.badge}</Badge>;
};

export default Badges;



// WEBPACK FOOTER //
// ./src/Components/Badges.jsx